import { Injectable } from '@angular/core';
import axios from 'axios';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AWSS3Service } from './aws.s3.service';
import { Observable } from 'rxjs';
import { AppConstants } from '../app.constants';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  // baseURL = 'https://api.virtuascript.net';
  baseURL = environment.apiUrl

  user: any;
  constructor(
    private s3: AWSS3Service,
    private http: HttpClient,
    private constant: AppConstants,
    private authService: AuthService,

  ) {
    this.user = this.authService.getUser();
  }

  updateUserState() {
    this.user = this.authService.getUser();
  }

  async importCategory(key) {
    try {
      const getPresignedURL = await this.s3.generatePresignedURL(key, "getObject");
      const payload = { "signedURL": getPresignedURL, email: this.user.email };

      const response = await axios.post(`${this.baseURL}/masterfile/category/import`, payload,
        {
          headers: {
            "x-api-key": environment.apiKey
          }
        });
      return response;
    } catch (error) {
      throw { error: "Error while importing data: " + error };
    }
  }

  async getAllCategory(): Promise<Observable<any>> {
    const response = await this.http.post("/masterfile/category", { sortBy: "name" })
    return response;
  }

  async getAllCategoryMasterfile(sortBy: string, level): Promise<Observable<any>> {
    const response = await this.http.post("/masterfile/category", { sortBy, level })
    return response;
  }

  async getStructuredCategory(): Promise<Observable<any>> {
    const response = await this.http.get("/masterfile/category/structured")
    return response;
  }

  async addCategory(params: any) {
    const response = await this.http.post("/masterfile/category/add", { ...params, email: this.user.email })
    return response;
  }

  async editCategory(params: any) {
    const response = await this.http.post("/masterfile/category/update", { ...params, email: this.user.email })
    return response;
  }

  async deleteCategory(ids) {
    const response = await this.http.post("/masterfile/category/delete", { ids, email: this.user.email })
    return response;
  }

  async exportCategory(): Promise<Observable<any>> {
    const response = this.http.post("/masterfile/category/export", { email: this.user.email });
    return response;
  }

  async exportCategoryTemplate(): Promise<Observable<any>> {
    const response = this.http.post("/masterfile/category/export-template", { email: this.user.email });
    return response;
  }
}
